/**
 * src/components/platform/FeatureGrid.js
 *
 * Grilla de FeatureCards.
 * Props: { features: Array<Feature> }
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'

define('FeatureGrid', ({ features = [] }) => {
    const grid = h('div', { className: 'feat-grid' })
    features.forEach(feat => grid.appendChild(c('FeatureCard', feat)))
    return grid
})
